export default __webpack_public_path__ + "assets/front/scss/formulaire.d0fa8eccaee30d56f1432c6f9002c5d9.css";